import { getPluginForScope } from '@adornis/buchungsheld-db/plugins/plugin.js';
import '@adornis/buchungsheld-theme/components/tr-entity-fields.js';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

const fieldBlackList = ['_id', '_class', '_collectionName', 'institutionID', 'userID'];

/**
 * @element bh-page-admin-einrichtung-form-config
 */
@customElement('bh-page-admin-einrichtung-form-config')
export class BhPageAdminEinrichtungFormConfig extends ChemistryLitElement {
  @property({ attribute: 'institution-id' }) institutionID = new RXController<string | null>(this, null);

  override render() {
    const institutionID = this.institutionID.value ?? 'default';
    const stammdatenPlugin = getPluginForScope('registration::stammdaten', institutionID);
    const classType = stammdatenPlugin.classType();
    console.log(institutionID, stammdatenPlugin);
    return html`
      <tr-entity-fields
        .userClass=${classType}
        page-title="Verfügbare Felder für die Registrierung"
        .fieldBlackList=${fieldBlackList}
      >
      </tr-entity-fields>
    `;
  }
}
